const PESEL_LENGTH = 11;
const PESEL_WAGES = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];

/**
 * Validates a PESEL number.
 * @param value - The PESEL number to validate.
 * @returns True if the PESEL number is valid, false otherwise.
 */
export const peselValidator = (value: string) => {
  if (!isPeselLengthValid(value) || !isControlNumberCorrect(value)) {
    return false;
  }
  return true;
};

const isPeselLengthValid = (pesel: string) => {
  return pesel.length === PESEL_LENGTH && !isNaN(Number(pesel));
};

const isControlNumberCorrect = (pesel: string) => {
  let controlSum = 0;
  for (let i = 0; i < 10; i++) {
    controlSum += parseInt(pesel[i], 10) * PESEL_WAGES[i];
  }

  let controlNumber = 10 - (controlSum % 10);
  if (controlNumber === 10) {
    controlNumber = 0;
  }

  return controlNumber === parseInt(pesel[10], 10);
};
